import React from "react";
import { usePut } from "../../../../api/useCall";
import t from "../../../../i18n";
import ModalForm from "@ui/Modal/Form";
import type { Project } from "../../../../api/useProjects";
import { browserTimeZones, defaultTimeZone } from "../../../../lib/time/intl";
import useInput from "@ui/lib/hooks/useInput";
import Select from "@ui/Select";

interface P {
  project: Project;
  onRequestClose: () => void;
}

const ChangeTimezoneModalForm = ({ project, onRequestClose }: P) => {
  const updateProject = usePut("/projects/:projectId(uuid)");

  const { value, dirty, onChange, setValue } = useInput(project.timezone);

  const timeZonesOptions = React.useMemo(() => {
    const timeZones = [...new Set([...browserTimeZones, defaultTimeZone])];
    return timeZones.map(tz => ({ value: tz, label: tz }));
  }, []);

  const handleRollbackTimeZone = React.useCallback(() => {
    setValue(project.timezone);
  }, [project.timezone, setValue]);

  const handleSubmit = React.useCallback(async () => {
    const updateProjectData = {
      ...project,
      timezone: value,
    };

    await updateProject({
      body: updateProjectData,
      routeParams: { projectId: project.id },
    });

    return true;
  }, [project, updateProject, value]);

  return (
    <ModalForm
      onSubmit={dirty ? handleSubmit : false}
      onRequestClose={onRequestClose}
      okButtonName={t("modalForm.button.name.modify")}
    >
      <Select
        filtered
        label={t("projects.modal.update_projects.title.timezone")}
        onChange={onChange}
        value={value}
        options={timeZonesOptions}
        prompt=""
        revertable={dirty}
        revert={handleRollbackTimeZone}
        clearable={false}
      />
    </ModalForm>
  );
};

export default React.memo(ChangeTimezoneModalForm);
